import { render, staticRenderFns } from "./Creditos.vue?vue&type=template&id=5bd02508&scoped=true&"
import script from "./Creditos.vue?vue&type=script&lang=js&"
export * from "./Creditos.vue?vue&type=script&lang=js&"
import style0 from "./Creditos.vue?vue&type=style&index=0&id=5bd02508&prod&lang=scss&scoped=true&"
import style1 from "./Creditos.vue?vue&type=style&index=1&id=5bd02508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd02508",
  null
  
)

export default component.exports